<template>
  <div class="awards" v-if="SiteMapData">
    <HeadBlock />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('網站導覽') }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>
    <div class="main siteMap">
      <div class="container">
        <div class="title">
          <h2 v-if="local == 'en'">SiteMap</h2>
          <h2 v-else>網站導覽</h2>
        </div>
        <div class="box">
          <div class="text_box" v-if="local == 'en'">
            <p>This website is built based on the principles of web accessibility design. The main content of the site
              is divided into three sections:</p>
            <ul class="list">
              <li>Top Function Area</li>
              <li>Central Content Area</li>
              <li>Footer Information Area</li>
            </ul>
            <hr class="line">
            <p>The website’s access key (keyboard shortcut) settings are as follows:</p>
            <ul class="list">
              <li>Alt+U: Top navigation area, which contains the main links of this website.</li>
              <li>Alt+C: Central content area.</li>
              <li>Alt+B: Footer information area.</li>
            </ul>
            <p>If you are using the Firefox browser, the keyboard shortcut method is Shift+Alt+(access key letter). For
              example, Shift+Alt+C will move focus to the central content area.</p>
          </div>
          <div class="text_box" v-else>
            <p>本網站依無障礙網頁設計原則建置，網站的主要內容分為三大區塊：</p>
            <ul class="list">
              <li>上方功能區塊</li>
              <li>中央內容區塊</li>
              <li>頁尾網站資訊</li>
            </ul>
            <hr class="line">
            <p>本網站的快速鍵﹝Accesskey﹞設定如下：</p>
            <ul class="list">
              <li>Alt+U：上方導覽連結區，此區塊列有本網站的主要連結。</li>
              <li>Alt+C：中央內容區塊。</li>
              <li>Alt+B：頁尾網站資訊。</li>
            </ul>
            <p>如果您的瀏覽器是Firefox，快速鍵的使用方法是 Shift+Alt+(快速鍵字母)，例如 Shift+Alt+C會跳至網頁中央區塊，以此類推。</p>
          </div>
          <hr class="line">
          <div class="map_box" v-if="SiteMapData.SiteMapMenus" v-for="(SiteMapMenu, index) in SiteMapData.SiteMapMenus"
            :key="index">
            <div class="map_title">{{ SiteMapMenu.MenuList.Name }}</div>
            <ul class="list">
              <li v-for="(MenuData, index_item) in SiteMapMenu.MenuListItems" :key="index_item">
                <a class="map_item title" :title="MenuData.Menu.Title" v-if="MenuData.Menu.Type == 0">{{
                  MenuData.Menu.Title }}
                </a>
                <a class="map_item title" :href="getLink(MenuData.Menu)"
                  :target="MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? '_blank' : ''"
                  :title="MenuData.Menu.Title + (MenuData.Menu.Type == 3 && MenuData.Menu.Blank ? ', 另開新視窗' : '')"
                  v-else>{{
                    MenuData.Menu.Title }}
                </a>
                <div v-if="MenuData.SubMenus" v-for="(SubMenu, index_sub) in MenuData.SubMenus" :key="index_sub">
                  <a class="map_item" :title="SubMenu.Title" v-if="SubMenu.Type == 0">{{
                    SubMenu.Title }}</a>
                  <a :href="getLink(SubMenu)" :target="SubMenu.Type == 3 && SubMenu.Blank ? '_blank' : ''"
                    class="map_item" :title="SubMenu.Title + (SubMenu.Type == 3 && SubMenu.Blank ? ', 另開新視窗' : '')"
                    v-else>{{
                      SubMenu.Title }}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <FooterBlock />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
    "網站導覽": "網站導覽",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
    "網站導覽": "StieMap",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "SiteMap",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
  },
  data() {
    return {
      SiteMapData: null,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/SiteMap",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_the_site_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.SiteMapData = response.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });    
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.SiteMapData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "SiteMapMenus": [
          {
            "MenuList": {
              "MLId": 5,
              "Name": "金曲獎頒獎典禮",
              "Remarks": "",
              "Serialize": "[{\"id\":\"root\",\"text\":\"根目錄(選單設定)\",\"icon\":\"fa fa-home\",\"li_attr\":{\"id\":\"root\"},\"a_attr\":{\"href\":\"#\",\"id\":\"root_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"#\",\"type\":\"default\"},{\"id\":\"94692d0d-43f0-479d-9950-2300781c9281\",\"text\":\"頒獎典禮\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"94692d0d-43f0-479d-9950-2300781c9281\"},\"a_attr\":{\"href\":\"#\",\"id\":\"94692d0d-43f0-479d-9950-2300781c9281_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"988cd64a-350c-4e0d-a977-8f90ac1c8064\",\"text\":\"贈票辦法\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"988cd64a-350c-4e0d-a977-8f90ac1c8064\"},\"a_attr\":{\"href\":\"#\",\"id\":\"988cd64a-350c-4e0d-a977-8f90ac1c8064_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":true,\"disabled\":false},\"data\":{},\"parent\":\"94692d0d-43f0-479d-9950-2300781c9281\",\"type\":\"default\"},{\"id\":\"0b40276c-651b-4e3d-8ff8-de993ec9e1ab\",\"text\":\"入圍&得獎\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"0b40276c-651b-4e3d-8ff8-de993ec9e1ab\"},\"a_attr\":{\"href\":\"#\",\"id\":\"0b40276c-651b-4e3d-8ff8-de993ec9e1ab_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"2619a43c-dc6e-45e6-944b-172da460065a\",\"text\":\"入圍&得獎 第36屆金曲獎入圍名單\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"2619a43c-dc6e-45e6-944b-172da460065a\"},\"a_attr\":{\"href\":\"#\",\"id\":\"2619a43c-dc6e-45e6-944b-172da460065a_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"0b40276c-651b-4e3d-8ff8-de993ec9e1ab\",\"type\":\"default\"},{\"id\":\"4ffe412d-307b-4ed5-beef-179c143009a3\",\"text\":\"歷屆得獎名單\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"4ffe412d-307b-4ed5-beef-179c143009a3\"},\"a_attr\":{\"href\":\"#\",\"id\":\"4ffe412d-307b-4ed5-beef-179c143009a3_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"0b40276c-651b-4e3d-8ff8-de993ec9e1ab\",\"type\":\"default\"},{\"id\":\"4a1d8939-4379-4820-91ed-9473b1eca1ae\",\"text\":\"典禮地點\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"4a1d8939-4379-4820-91ed-9473b1eca1ae\"},\"a_attr\":{\"href\":\"#\",\"id\":\"4a1d8939-4379-4820-91ed-9473b1eca1ae_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"4918a0c6-e808-4676-a0ac-fdb5dc7f5961\",\"text\":\"影音專區\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"4918a0c6-e808-4676-a0ac-fdb5dc7f5961\"},\"a_attr\":{\"href\":\"#\",\"id\":\"4918a0c6-e808-4676-a0ac-fdb5dc7f5961_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"a572ff3b-6f9e-4593-9cc1-9885ade51683\",\"text\":\"影音花絮\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"a572ff3b-6f9e-4593-9cc1-9885ade51683\"},\"a_attr\":{\"href\":\"#\",\"id\":\"a572ff3b-6f9e-4593-9cc1-9885ade51683_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"4918a0c6-e808-4676-a0ac-fdb5dc7f5961\",\"type\":\"default\"}]",
              "IsSiteMap": true,
              "Lang": "zh_tw",
              "CreateTime": "2025-03-31T11:13:56.64",
              "LastEditTime": "2025-06-10T03:19:16.733"
            },
            "MenuListItems": [
              {
                "Menu": {
                  "MLIId": 67,
                  "MLId": 5,
                  "Id": "94692d0d-43f0-479d-9950-2300781c9281",
                  "ParentId": "root",
                  "Title": "頒獎典禮",
                  "Description": "贈票辦法",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 1,
                  "CreateTime": "2025-03-31T11:12:42.59",
                  "LastEditTime": "2025-06-10T03:19:16.747",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 785,
                    "MLId": 5,
                    "Id": "988cd64a-350c-4e0d-a977-8f90ac1c8064",
                    "ParentId": "94692d0d-43f0-479d-9950-2300781c9281",
                    "Title": "贈票辦法",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 2,
                    "CreateTime": "2025-06-10T03:18:58.85",
                    "LastEditTime": "2025-06-10T03:19:16.753",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 68,
                  "MLId": 5,
                  "Id": "0b40276c-651b-4e3d-8ff8-de993ec9e1ab",
                  "ParentId": "root",
                  "Title": "入圍&得獎",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 3,
                  "CreateTime": "2025-03-31T11:12:52.033",
                  "LastEditTime": "2025-06-10T03:19:16.76",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 72,
                    "MLId": 5,
                    "Id": "2619a43c-dc6e-45e6-944b-172da460065a",
                    "ParentId": "0b40276c-651b-4e3d-8ff8-de993ec9e1ab",
                    "Title": "入圍&得獎 第36屆金曲獎入圍名單",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 3,
                    "CId": -1,
                    "PId": -1,
                    "Url": "/gma/36th/#/Awards/AwardWinners",
                    "Blank": false,
                    "Sort": 4,
                    "CreateTime": "2025-03-31T11:13:42.06",
                    "LastEditTime": "2025-06-10T03:19:16.767",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 73,
                    "MLId": 5,
                    "Id": "4ffe412d-307b-4ed5-beef-179c143009a3",
                    "ParentId": "0b40276c-651b-4e3d-8ff8-de993ec9e1ab",
                    "Title": "歷屆得獎名單",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 48,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 5,
                    "CreateTime": "2025-03-31T11:13:49.82",
                    "LastEditTime": "2025-06-10T03:19:16.773",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 343,
                  "MLId": 5,
                  "Id": "4a1d8939-4379-4820-91ed-9473b1eca1ae",
                  "ParentId": "root",
                  "Title": "典禮地點",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 99,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 6,
                  "CreateTime": "2025-05-08T09:53:10.813",
                  "LastEditTime": "2025-06-10T03:19:16.78",
                  "IsWinner": false
                },
                "SubMenus": null
              },
              {
                "Menu": {
                  "MLIId": 618,
                  "MLId": 5,
                  "Id": "4918a0c6-e808-4676-a0ac-fdb5dc7f5961",
                  "ParentId": "root",
                  "Title": "影音專區",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 7,
                  "CreateTime": "2025-05-26T06:26:34.883",
                  "LastEditTime": "2025-06-10T03:19:16.787",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 619,
                    "MLId": 5,
                    "Id": "a572ff3b-6f9e-4593-9cc1-9885ade51683",
                    "ParentId": "4918a0c6-e808-4676-a0ac-fdb5dc7f5961",
                    "Title": "影音花絮",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 149,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 8,
                    "CreateTime": "2025-05-26T06:26:45.503",
                    "LastEditTime": "2025-06-10T03:19:16.79",
                    "IsWinner": false
                  }
                ]
              }
            ]
          },
          {
            "MenuList": {
              "MLId": 25,
              "Name": "金曲國際音樂節",
              "Remarks": "",
              "Serialize": "[{\"id\":\"root\",\"text\":\"根目錄(選單設定)\",\"icon\":\"fa fa-home\",\"li_attr\":{\"id\":\"root\"},\"a_attr\":{\"href\":\"#\",\"id\":\"root_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"#\",\"type\":\"default\"},{\"id\":\"bf99a1d1-3471-4729-8a25-7110a919d9c3\",\"text\":\"活動日程表\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"bf99a1d1-3471-4729-8a25-7110a919d9c3\"},\"a_attr\":{\"href\":\"#\",\"id\":\"bf99a1d1-3471-4729-8a25-7110a919d9c3_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"text\":\"系列活動\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\"},\"a_attr\":{\"href\":\"#\",\"id\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":true,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"6c5187d3-e9f6-46a3-9af7-8067d6297005\",\"text\":\"音樂論壇\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"6c5187d3-e9f6-46a3-9af7-8067d6297005\"},\"a_attr\":{\"href\":\"#\",\"id\":\"6c5187d3-e9f6-46a3-9af7-8067d6297005_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"bc23b28a-1367-42d0-a419-84e23b7f5af8\",\"text\":\"商務交流會\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"bc23b28a-1367-42d0-a419-84e23b7f5af8\"},\"a_attr\":{\"href\":\"#\",\"id\":\"bc23b28a-1367-42d0-a419-84e23b7f5af8_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"cfa7cd48-8391-4b81-ac7b-07ef1be2c089\",\"text\":\"商務媒合會\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"cfa7cd48-8391-4b81-ac7b-07ef1be2c089\"},\"a_attr\":{\"href\":\"#\",\"id\":\"cfa7cd48-8391-4b81-ac7b-07ef1be2c089_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"1f1ef191-190a-45f6-8087-7922aa82331f\",\"text\":\"商展交易中心\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"1f1ef191-190a-45f6-8087-7922aa82331f\"},\"a_attr\":{\"href\":\"#\",\"id\":\"1f1ef191-190a-45f6-8087-7922aa82331f_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"0e8cc222-7aec-4a0e-ab15-858ce78413b6\",\"text\":\"SHOWCASE售票演唱會\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"0e8cc222-7aec-4a0e-ab15-858ce78413b6\"},\"a_attr\":{\"href\":\"#\",\"id\":\"0e8cc222-7aec-4a0e-ab15-858ce78413b6_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"ac3813ad-aa4e-4deb-9255-117ffe59dd7c\",\"text\":\"國際音樂節交流計畫\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"ac3813ad-aa4e-4deb-9255-117ffe59dd7c\"},\"a_attr\":{\"href\":\"#\",\"id\":\"ac3813ad-aa4e-4deb-9255-117ffe59dd7c_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"df1b966d-23fb-4c61-b18c-1d9c673bb480\",\"text\":\"金曲36入圍新人演出\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"df1b966d-23fb-4c61-b18c-1d9c673bb480\"},\"a_attr\":{\"href\":\"#\",\"id\":\"df1b966d-23fb-4c61-b18c-1d9c673bb480_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"7565a9b4-1b10-439d-bf41-6def6c9042a1\",\"type\":\"default\"},{\"id\":\"515960a6-c5be-45d1-a699-0f5c7f68383a\",\"text\":\"場地資訊\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"515960a6-c5be-45d1-a699-0f5c7f68383a\"},\"a_attr\":{\"href\":\"#\",\"id\":\"515960a6-c5be-45d1-a699-0f5c7f68383a_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"a46cc13f-8e10-4206-9c53-d88d96569429\",\"text\":\"台北寒舍艾美酒店\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"a46cc13f-8e10-4206-9c53-d88d96569429\"},\"a_attr\":{\"href\":\"#\",\"id\":\"a46cc13f-8e10-4206-9c53-d88d96569429_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"515960a6-c5be-45d1-a699-0f5c7f68383a\",\"type\":\"default\"},{\"id\":\"fac99d37-3172-4374-bc1f-dc82731f7e2c\",\"text\":\"Corner Max 大角落多功能展演館\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"fac99d37-3172-4374-bc1f-dc82731f7e2c\"},\"a_attr\":{\"href\":\"#\",\"id\":\"fac99d37-3172-4374-bc1f-dc82731f7e2c_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"515960a6-c5be-45d1-a699-0f5c7f68383a\",\"type\":\"default\"},{\"id\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f\",\"text\":\"住宿資訊\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f\"},\"a_attr\":{\"href\":\"#\",\"id\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"aa45d9db-81a9-4334-8e0c-c8eb252a730a\",\"text\":\"台北寒舍艾美酒店\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"aa45d9db-81a9-4334-8e0c-c8eb252a730a\"},\"a_attr\":{\"href\":\"#\",\"id\":\"aa45d9db-81a9-4334-8e0c-c8eb252a730a_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f\",\"type\":\"default\"},{\"id\":\"ac2848a6-bf47-4b24-acb1-4eee4e302d6a\",\"text\":\"台北艾麗酒店\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"ac2848a6-bf47-4b24-acb1-4eee4e302d6a\"},\"a_attr\":{\"href\":\"#\",\"id\":\"ac2848a6-bf47-4b24-acb1-4eee4e302d6a_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f\",\"type\":\"default\"},{\"id\":\"8e46f429-5d3c-419e-88eb-f9f98e8c3f61\",\"text\":\"國聯大飯店\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"8e46f429-5d3c-419e-88eb-f9f98e8c3f61\"},\"a_attr\":{\"href\":\"#\",\"id\":\"8e46f429-5d3c-419e-88eb-f9f98e8c3f61_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"c032c64a-de27-42b4-b5b6-e3f1c0ec007f\",\"type\":\"default\"}]",
              "IsSiteMap": true,
              "Lang": "zh_tw",
              "CreateTime": "2025-05-05T16:25:00.463",
              "LastEditTime": "2025-06-02T07:27:38.373"
            },
            "MenuListItems": [
              {
                "Menu": {
                  "MLIId": 315,
                  "MLId": 25,
                  "Id": "bf99a1d1-3471-4729-8a25-7110a919d9c3",
                  "ParentId": "root",
                  "Title": "活動日程表",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 1,
                  "CreateTime": "2025-05-05T16:21:57.323",
                  "LastEditTime": "2025-06-02T07:27:38.38",
                  "IsWinner": false
                },
                "SubMenus": null
              },
              {
                "Menu": {
                  "MLIId": 316,
                  "MLId": 25,
                  "Id": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                  "ParentId": "root",
                  "Title": "系列活動",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 67,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 2,
                  "CreateTime": "2025-05-05T16:22:11.363",
                  "LastEditTime": "2025-06-02T07:27:38.387",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 317,
                    "MLId": 25,
                    "Id": "6c5187d3-e9f6-46a3-9af7-8067d6297005",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "音樂論壇",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 59,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 3,
                    "CreateTime": "2025-05-05T16:22:21.2",
                    "LastEditTime": "2025-06-02T07:27:38.393",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 318,
                    "MLId": 25,
                    "Id": "bc23b28a-1367-42d0-a419-84e23b7f5af8",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "商務交流會",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 68,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 4,
                    "CreateTime": "2025-05-05T16:22:30.37",
                    "LastEditTime": "2025-06-02T07:27:38.4",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 319,
                    "MLId": 25,
                    "Id": "cfa7cd48-8391-4b81-ac7b-07ef1be2c089",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "商務媒合會",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 5,
                    "CreateTime": "2025-05-05T16:22:36.977",
                    "LastEditTime": "2025-06-02T07:27:38.403",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 320,
                    "MLId": 25,
                    "Id": "1f1ef191-190a-45f6-8087-7922aa82331f",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "商展交易中心",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 285,
                    "Url": "",
                    "Blank": false,
                    "Sort": 6,
                    "CreateTime": "2025-05-05T16:22:49.367",
                    "LastEditTime": "2025-06-02T07:27:38.41",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 321,
                    "MLId": 25,
                    "Id": "0e8cc222-7aec-4a0e-ab15-858ce78413b6",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "SHOWCASE售票演唱會",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 52,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 7,
                    "CreateTime": "2025-05-05T16:22:57.85",
                    "LastEditTime": "2025-06-02T07:27:38.413",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 322,
                    "MLId": 25,
                    "Id": "ac3813ad-aa4e-4deb-9255-117ffe59dd7c",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "國際音樂節交流計畫",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 61,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 8,
                    "CreateTime": "2025-05-05T16:23:14.893",
                    "LastEditTime": "2025-06-02T07:27:38.42",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 323,
                    "MLId": 25,
                    "Id": "df1b966d-23fb-4c61-b18c-1d9c673bb480",
                    "ParentId": "7565a9b4-1b10-439d-bf41-6def6c9042a1",
                    "Title": "金曲36入圍新人演出",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": 62,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 9,
                    "CreateTime": "2025-05-05T16:23:27.67",
                    "LastEditTime": "2025-06-02T07:27:38.427",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 324,
                  "MLId": 25,
                  "Id": "515960a6-c5be-45d1-a699-0f5c7f68383a",
                  "ParentId": "root",
                  "Title": "場地資訊",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 51,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 10,
                  "CreateTime": "2025-05-05T16:23:39.65",
                  "LastEditTime": "2025-06-02T07:27:38.43",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 325,
                    "MLId": 25,
                    "Id": "a46cc13f-8e10-4206-9c53-d88d96569429",
                    "ParentId": "515960a6-c5be-45d1-a699-0f5c7f68383a",
                    "Title": "台北寒舍艾美酒店",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 146,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 11,
                    "CreateTime": "2025-05-05T16:23:59.513",
                    "LastEditTime": "2025-06-02T07:27:38.437",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 326,
                    "MLId": 25,
                    "Id": "fac99d37-3172-4374-bc1f-dc82731f7e2c",
                    "ParentId": "515960a6-c5be-45d1-a699-0f5c7f68383a",
                    "Title": "Corner Max 大角落多功能展演館",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 145,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 12,
                    "CreateTime": "2025-05-05T16:24:07.89",
                    "LastEditTime": "2025-06-02T07:27:38.44",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 327,
                  "MLId": 25,
                  "Id": "c032c64a-de27-42b4-b5b6-e3f1c0ec007f",
                  "ParentId": "root",
                  "Title": "住宿資訊",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 65,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 13,
                  "CreateTime": "2025-05-05T16:24:14.347",
                  "LastEditTime": "2025-06-02T07:27:38.45",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 328,
                    "MLId": 25,
                    "Id": "aa45d9db-81a9-4334-8e0c-c8eb252a730a",
                    "ParentId": "c032c64a-de27-42b4-b5b6-e3f1c0ec007f",
                    "Title": "台北寒舍艾美酒店",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 144,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 14,
                    "CreateTime": "2025-05-05T16:24:26.533",
                    "LastEditTime": "2025-06-02T07:27:38.457",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 329,
                    "MLId": 25,
                    "Id": "ac2848a6-bf47-4b24-acb1-4eee4e302d6a",
                    "ParentId": "c032c64a-de27-42b4-b5b6-e3f1c0ec007f",
                    "Title": "台北艾麗酒店",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 143,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 15,
                    "CreateTime": "2025-05-05T16:24:31.35",
                    "LastEditTime": "2025-06-02T07:27:38.46",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 330,
                    "MLId": 25,
                    "Id": "8e46f429-5d3c-419e-88eb-f9f98e8c3f61",
                    "ParentId": "c032c64a-de27-42b4-b5b6-e3f1c0ec007f",
                    "Title": "國聯大飯店",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 142,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 16,
                    "CreateTime": "2025-05-05T16:24:39.373",
                    "LastEditTime": "2025-06-02T07:27:38.467",
                    "IsWinner": false
                  }
                ]
              }
            ]
          }
        ]
      };
    } else {
      this.SiteMapData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "SiteMapMenus": [
          {
            "MenuList": {
              "MLId": 27,
              "Name": " Golden Melody Awards",
              "Remarks": "",
              "Serialize": "[{\"id\":\"root\",\"text\":\"根目錄(選單設定)\",\"icon\":\"fa fa-home\",\"li_attr\":{\"id\":\"root\"},\"a_attr\":{\"href\":\"#\",\"id\":\"root_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"#\",\"type\":\"default\"},{\"id\":\"91666795-3be7-4ee7-8ea2-ea5f55f5b831\",\"text\":\"Awards Ceremony\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"91666795-3be7-4ee7-8ea2-ea5f55f5b831\"},\"a_attr\":{\"href\":\"#\",\"id\":\"91666795-3be7-4ee7-8ea2-ea5f55f5b831_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"32f47b05-55e2-4f07-a988-78695be0f45b\",\"text\":\"Nomination\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"32f47b05-55e2-4f07-a988-78695be0f45b\"},\"a_attr\":{\"href\":\"#\",\"id\":\"32f47b05-55e2-4f07-a988-78695be0f45b_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":true,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"75db3130-aa39-4deb-b583-f48eec22bde9\",\"text\":\"Getting here\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"75db3130-aa39-4deb-b583-f48eec22bde9\"},\"a_attr\":{\"href\":\"#\",\"id\":\"75db3130-aa39-4deb-b583-f48eec22bde9_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"}]",
              "IsSiteMap": true,
              "Lang": "en",
              "CreateTime": "2025-05-08T09:59:51.97",
              "LastEditTime": "2025-05-08T10:22:39.9"
            },
            "MenuListItems": [
              {
                "Menu": {
                  "MLIId": 348,
                  "MLId": 27,
                  "Id": "91666795-3be7-4ee7-8ea2-ea5f55f5b831",
                  "ParentId": "root",
                  "Title": "Awards Ceremony",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 1,
                  "CreateTime": "2025-05-08T10:00:51.347",
                  "LastEditTime": "2025-05-08T10:22:39.9",
                  "IsWinner": false
                },
                "SubMenus": null
              },
              {
                "Menu": {
                  "MLIId": 349,
                  "MLId": 27,
                  "Id": "32f47b05-55e2-4f07-a988-78695be0f45b",
                  "ParentId": "root",
                  "Title": "Nomination",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": -1,
                  "PId": -1,
                  "Url": "/gma/36th/#/Awards/AwardWinners",
                  "Blank": false,
                  "Sort": 2,
                  "CreateTime": "2025-05-08T10:00:56.003",
                  "LastEditTime": "2025-05-08T10:22:39.9",
                  "IsWinner": false
                },
                "SubMenus": null
              },
              {
                "Menu": {
                  "MLIId": 350,
                  "MLId": 27,
                  "Id": "75db3130-aa39-4deb-b583-f48eec22bde9",
                  "ParentId": "root",
                  "Title": "Getting here",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 2,
                  "CId": 110,
                  "PId": 383,
                  "Url": "",
                  "Blank": false,
                  "Sort": 3,
                  "CreateTime": "2025-05-08T10:01:27.24",
                  "LastEditTime": "2025-05-08T10:22:39.9",
                  "IsWinner": false
                },
                "SubMenus": null
              }
            ]
          },
          {
            "MenuList": {
              "MLId": 28,
              "Name": "Golden Melody Festival",
              "Remarks": "",
              "Serialize": "[{\"id\":\"root\",\"text\":\"根目錄(選單設定)\",\"icon\":\"fa fa-home\",\"li_attr\":{\"id\":\"root\"},\"a_attr\":{\"href\":\"#\",\"id\":\"root_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"#\",\"type\":\"default\"},{\"id\":\"848dbd33-7a90-4b4e-b595-40211c6871ad\",\"text\":\"Schedule\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"848dbd33-7a90-4b4e-b595-40211c6871ad\"},\"a_attr\":{\"href\":\"#\",\"id\":\"848dbd33-7a90-4b4e-b595-40211c6871ad_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"text\":\"Events\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\"},\"a_attr\":{\"href\":\"#\",\"id\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"b33e848c-b823-425a-ac83-8b7c54d1925b\",\"text\":\"Conference\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"b33e848c-b823-425a-ac83-8b7c54d1925b\"},\"a_attr\":{\"href\":\"#\",\"id\":\"b33e848c-b823-425a-ac83-8b7c54d1925b_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"e49c3b27-c793-4b53-8765-9f4be1008374\",\"text\":\"Speed Meeting\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"e49c3b27-c793-4b53-8765-9f4be1008374\"},\"a_attr\":{\"href\":\"#\",\"id\":\"e49c3b27-c793-4b53-8765-9f4be1008374_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"6f5f865a-0675-4427-ae7c-3a24c8b08b54\",\"text\":\"Pitching\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"6f5f865a-0675-4427-ae7c-3a24c8b08b54\"},\"a_attr\":{\"href\":\"#\",\"id\":\"6f5f865a-0675-4427-ae7c-3a24c8b08b54_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"868c641f-dee6-4441-8879-dd618e8c9094\",\"text\":\"Biz Matching Center\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"868c641f-dee6-4441-8879-dd618e8c9094\"},\"a_attr\":{\"href\":\"#\",\"id\":\"868c641f-dee6-4441-8879-dd618e8c9094_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"ccba0138-9f97-4ddc-9bc6-09e914112d13\",\"text\":\"SHOWCASE\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"ccba0138-9f97-4ddc-9bc6-09e914112d13\"},\"a_attr\":{\"href\":\"#\",\"id\":\"ccba0138-9f97-4ddc-9bc6-09e914112d13_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"ed2e9b51-165c-4edb-83dc-07b23d636b42\",\"text\":\"GMA Partnerships\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"ed2e9b51-165c-4edb-83dc-07b23d636b42\"},\"a_attr\":{\"href\":\"#\",\"id\":\"ed2e9b51-165c-4edb-83dc-07b23d636b42_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"9d3f0f2e-5045-4990-9c21-c25be340cc7d\",\"text\":\"36th GMA Best New Artist Nominees Performances\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"9d3f0f2e-5045-4990-9c21-c25be340cc7d\"},\"a_attr\":{\"href\":\"#\",\"id\":\"9d3f0f2e-5045-4990-9c21-c25be340cc7d_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":true,\"disabled\":false},\"data\":{},\"parent\":\"710c0429-ce35-4f55-b12b-14cd93cc27c8\",\"type\":\"default\"},{\"id\":\"36b2c941-a713-4654-9c78-0d44050ce12e\",\"text\":\"Venue Information\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"36b2c941-a713-4654-9c78-0d44050ce12e\"},\"a_attr\":{\"href\":\"#\",\"id\":\"36b2c941-a713-4654-9c78-0d44050ce12e_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"bd36b233-5934-4b95-b3b7-e4ebbd847290\",\"text\":\"Le Méridien Taipei\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"bd36b233-5934-4b95-b3b7-e4ebbd847290\"},\"a_attr\":{\"href\":\"#\",\"id\":\"bd36b233-5934-4b95-b3b7-e4ebbd847290_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"36b2c941-a713-4654-9c78-0d44050ce12e\",\"type\":\"default\"},{\"id\":\"5ae65e7e-106e-4075-8c47-201f4e4bfa06\",\"text\":\"Corner Max \",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"5ae65e7e-106e-4075-8c47-201f4e4bfa06\"},\"a_attr\":{\"href\":\"#\",\"id\":\"5ae65e7e-106e-4075-8c47-201f4e4bfa06_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"36b2c941-a713-4654-9c78-0d44050ce12e\",\"type\":\"default\"},{\"id\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577\",\"text\":\"Accommodation information\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577\"},\"a_attr\":{\"href\":\"#\",\"id\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577_anchor\"},\"state\":{\"loaded\":true,\"opened\":true,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"root\",\"type\":\"default\"},{\"id\":\"cc692aa9-67fa-4758-a76d-fc386b125a83\",\"text\":\"Le Méridien Taipei\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"cc692aa9-67fa-4758-a76d-fc386b125a83\"},\"a_attr\":{\"href\":\"#\",\"id\":\"cc692aa9-67fa-4758-a76d-fc386b125a83_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577\",\"type\":\"default\"},{\"id\":\"4252ca97-3451-4874-9f7e-b64764ae7f17\",\"text\":\"Humble House Taipei\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"4252ca97-3451-4874-9f7e-b64764ae7f17\"},\"a_attr\":{\"href\":\"#\",\"id\":\"4252ca97-3451-4874-9f7e-b64764ae7f17_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577\",\"type\":\"default\"},{\"id\":\"7a401eef-b649-4c65-b7e3-bccc256a419b\",\"text\":\"United Hotel\",\"icon\":\"fa fa-list\",\"li_attr\":{\"id\":\"7a401eef-b649-4c65-b7e3-bccc256a419b\"},\"a_attr\":{\"href\":\"#\",\"id\":\"7a401eef-b649-4c65-b7e3-bccc256a419b_anchor\"},\"state\":{\"loaded\":true,\"opened\":false,\"selected\":false,\"disabled\":false},\"data\":{},\"parent\":\"3fde6af6-8c4f-4da6-8c17-ce07e5023577\",\"type\":\"default\"}]",
              "IsSiteMap": true,
              "Lang": "en",
              "CreateTime": "2025-05-08T10:00:30.21",
              "LastEditTime": "2025-05-16T08:56:28.987"
            },
            "MenuListItems": [
              {
                "Menu": {
                  "MLIId": 351,
                  "MLId": 28,
                  "Id": "848dbd33-7a90-4b4e-b595-40211c6871ad",
                  "ParentId": "root",
                  "Title": "Schedule",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 0,
                  "CId": -1,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 1,
                  "CreateTime": "2025-05-08T10:02:40.46",
                  "LastEditTime": "2025-05-16T08:56:28.997",
                  "IsWinner": false
                },
                "SubMenus": null
              },
              {
                "Menu": {
                  "MLIId": 352,
                  "MLId": 28,
                  "Id": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                  "ParentId": "root",
                  "Title": "Events",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 3,
                  "CId": -1,
                  "PId": -1,
                  "Url": "/gma/36th/#/Festival/",
                  "Blank": false,
                  "Sort": 2,
                  "CreateTime": "2025-05-08T10:02:52.1",
                  "LastEditTime": "2025-05-16T08:56:29",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 353,
                    "MLId": 28,
                    "Id": "b33e848c-b823-425a-ac83-8b7c54d1925b",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "Conference",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 3,
                    "CreateTime": "2025-05-08T10:03:22.343",
                    "LastEditTime": "2025-05-16T08:56:29.007",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 354,
                    "MLId": 28,
                    "Id": "e49c3b27-c793-4b53-8765-9f4be1008374",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "Speed Meeting",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 4,
                    "CreateTime": "2025-05-08T10:03:44.14",
                    "LastEditTime": "2025-05-16T08:56:29.017",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 355,
                    "MLId": 28,
                    "Id": "6f5f865a-0675-4427-ae7c-3a24c8b08b54",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "Pitching",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 5,
                    "CreateTime": "2025-05-08T10:04:05.43",
                    "LastEditTime": "2025-05-16T08:56:29.02",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 356,
                    "MLId": 28,
                    "Id": "868c641f-dee6-4441-8879-dd618e8c9094",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "Biz Matching Center",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 6,
                    "CreateTime": "2025-05-08T10:04:23.773",
                    "LastEditTime": "2025-05-16T08:56:29.03",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 357,
                    "MLId": 28,
                    "Id": "ccba0138-9f97-4ddc-9bc6-09e914112d13",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "SHOWCASE",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 1,
                    "CId": 116,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 7,
                    "CreateTime": "2025-05-08T10:04:29.517",
                    "LastEditTime": "2025-05-16T08:56:29.037",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 358,
                    "MLId": 28,
                    "Id": "ed2e9b51-165c-4edb-83dc-07b23d636b42",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "GMA Partnerships",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 8,
                    "CreateTime": "2025-05-08T10:04:49.643",
                    "LastEditTime": "2025-05-16T08:56:29.043",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 359,
                    "MLId": 28,
                    "Id": "9d3f0f2e-5045-4990-9c21-c25be340cc7d",
                    "ParentId": "710c0429-ce35-4f55-b12b-14cd93cc27c8",
                    "Title": "36th GMA Best New Artist Nominees Performances",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 0,
                    "CId": -1,
                    "PId": -1,
                    "Url": "",
                    "Blank": false,
                    "Sort": 9,
                    "CreateTime": "2025-05-08T10:05:08.12",
                    "LastEditTime": "2025-05-16T08:56:29.05",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 360,
                  "MLId": 28,
                  "Id": "36b2c941-a713-4654-9c78-0d44050ce12e",
                  "ParentId": "root",
                  "Title": "Venue Information",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 119,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 10,
                  "CreateTime": "2025-05-08T10:05:23.977",
                  "LastEditTime": "2025-05-16T08:56:29.057",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 361,
                    "MLId": 28,
                    "Id": "bd36b233-5934-4b95-b3b7-e4ebbd847290",
                    "ParentId": "36b2c941-a713-4654-9c78-0d44050ce12e",
                    "Title": "Le Méridien Taipei",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 425,
                    "Url": "",
                    "Blank": false,
                    "Sort": 11,
                    "CreateTime": "2025-05-08T10:05:35.45",
                    "LastEditTime": "2025-05-16T08:56:29.063",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 362,
                    "MLId": 28,
                    "Id": "5ae65e7e-106e-4075-8c47-201f4e4bfa06",
                    "ParentId": "36b2c941-a713-4654-9c78-0d44050ce12e",
                    "Title": "Corner Max ",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 426,
                    "Url": "",
                    "Blank": false,
                    "Sort": 12,
                    "CreateTime": "2025-05-08T10:05:49.953",
                    "LastEditTime": "2025-05-16T08:56:29.07",
                    "IsWinner": false
                  }
                ]
              },
              {
                "Menu": {
                  "MLIId": 363,
                  "MLId": 28,
                  "Id": "3fde6af6-8c4f-4da6-8c17-ce07e5023577",
                  "ParentId": "root",
                  "Title": "Accommodation information",
                  "Description": "",
                  "IsVisable": true,
                  "Image": "",
                  "Color": "",
                  "Type": 1,
                  "CId": 123,
                  "PId": -1,
                  "Url": "",
                  "Blank": false,
                  "Sort": 13,
                  "CreateTime": "2025-05-08T10:07:10.603",
                  "LastEditTime": "2025-05-16T08:56:29.077",
                  "IsWinner": false
                },
                "SubMenus": [
                  {
                    "MLIId": 364,
                    "MLId": 28,
                    "Id": "cc692aa9-67fa-4758-a76d-fc386b125a83",
                    "ParentId": "3fde6af6-8c4f-4da6-8c17-ce07e5023577",
                    "Title": "Le Méridien Taipei",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 425,
                    "Url": "",
                    "Blank": false,
                    "Sort": 14,
                    "CreateTime": "2025-05-08T10:07:34.577",
                    "LastEditTime": "2025-05-16T08:56:29.087",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 365,
                    "MLId": 28,
                    "Id": "4252ca97-3451-4874-9f7e-b64764ae7f17",
                    "ParentId": "3fde6af6-8c4f-4da6-8c17-ce07e5023577",
                    "Title": "Humble House Taipei",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 427,
                    "Url": "",
                    "Blank": false,
                    "Sort": 15,
                    "CreateTime": "2025-05-08T10:08:01.51",
                    "LastEditTime": "2025-05-16T08:56:29.093",
                    "IsWinner": false
                  },
                  {
                    "MLIId": 366,
                    "MLId": 28,
                    "Id": "7a401eef-b649-4c65-b7e3-bccc256a419b",
                    "ParentId": "3fde6af6-8c4f-4da6-8c17-ce07e5023577",
                    "Title": "United Hotel",
                    "Description": "",
                    "IsVisable": true,
                    "Image": "",
                    "Color": "",
                    "Type": 2,
                    "CId": -1,
                    "PId": 428,
                    "Url": "",
                    "Blank": false,
                    "Sort": 16,
                    "CreateTime": "2025-05-08T10:08:19.42",
                    "LastEditTime": "2025-05-16T08:56:29.097",
                    "IsWinner": false
                  }
                ]
              }
            ]
          }
        ]
      };
    }
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPostByPId: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    goto: function (MenuData) {
      if (MenuData.Type == 1) {
        this.gotoCategoryByCId(MenuData.CId);
      } else if (MenuData.Type == 2) {
        this.gotoPostByPId(MenuData.PId);
      } else if (MenuData.Type == 3) {
        this.gotoUrl(MenuData.Url, MenuData.Blank);
      }
    },
    getLink: function (MenuData) {
      if (MenuData.Type == 1) {
        const routeData = this.$router.resolve({
          name: "Category",
          params: { CId: MenuData.CId },
        });
        return routeData.href;
      } else if (MenuData.Type == 2) {
        const routeData = this.$router.resolve({
          name: "Post",
          params: { PId: MenuData.PId },
        });
        return routeData.href;
      } else if (MenuData.Type == 3) {
        return MenuData.Url;
      }
      return 'javascript:void(0)';
    },
  },
};
</script>